// src/domains/sales/deals/pages/create-bko-page/sales-deals-bko-create-page.jsx

import SalesDealsApi from 'api/admins/sales-deals-api'
import { RedirectButton, TitlePage } from 'components/atoms'
import { useHistory } from 'react-router-dom'
import { ALERT_TYPES } from 'constants/alert-constants'
import SalesDealsBkoCreateForm from '../../forms/create-bko-form/sales-deals-bko-create-form'
import PropTypes from 'prop-types'
import { Card } from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const buildFullName = (firstName, lastName) => {
  const first = (firstName || '').trim()
  const last  = (lastName || '').trim()
  return [ first, last ].filter(Boolean).join(' ').trim()
}

const SalesDealsBkoCreatePage = ({ pageUtils }) => {
  const history = useHistory()

  const handleSubmitForm = async (values, formikBag) => {
    const {
      product_ids,
      product_search,
      hide_existing_user_detail,

      first_name,
      last_name,

      dp_transfer_proofs, // ✅ new
      ...payload
    } = values || {}

    // Always submit full name as "name" to backend
    const fullName = buildFullName(first_name, last_name)
    if(fullName){
      payload.name = fullName
    }

    // ✅ assist_by_list cleanup + backward compatible string assist_by
    const cleanedAssistList = (payload.assist_by_list || [])
      .map((x) => (x || '').toString().trim())
      .filter(Boolean)

    payload.assist_by_list = Array.from(new Set(cleanedAssistList))
    payload.assist_by = payload.assist_by_list.join(', ')

    payload.po_condition_id = values.po_condition_id
    payload.po_comes_with   = values.po_comes_with
    payload.po_designer_id  = values.po_designer_id
    payload.po_category_id  = values.po_category_id

    // Only send expected keys inside items[]
    payload.items = (payload.items || []).map((it) => ({
      product_id: it.product_id,
      selling_price: it.selling_price,
      authenticator: it.authenticator,
      authenticity_check_note: it.authenticity_check_note,
      include_authenticity_check: it.include_authenticity_check,
      note: it.note,
    }))

    try {
      const response = await SalesDealsApi.create(payload)
      const deal = response.data.data

      // ✅ Upload DP proof(s) AFTER create (so create endpoint stays JSON)
      const files = dp_transfer_proofs || []
      if (files.length > 0) {
        try {
          await SalesDealsApi.uploadDownPaymentProof(deal.id, files)
        } catch (e) {
          // Deal is already created — show warning only
          pageUtils.setAlertMsg(
            'Deals berhasil dibuat, tapi upload Bukti Transfer DP gagal. Silakan upload manual dari detail deal.',
            ALERT_TYPES.DANGER
          )
        }
      }

      const msg = (
        <>
          { 'Deals PO/BKO berhasil dibuat' } &nbsp;
          <RedirectButton
            text={ 'Lihat Detail Deals' }
            path={ `/app/sales/deals/${deal.id}` }
          />
        </>
      )
      pageUtils.setAlertMsg(msg, ALERT_TYPES.SUCCESS)
      formikBag.resetForm()

      // ✅ Always redirect so user won’t create twice
      history.push(`/app/sales/deals/${deal.id}`)

    } catch (error) {
      formikBag.setErrors(error?.response?.data?.messages)
      pageUtils.setApiErrorMsg(error?.response?.data || error)
    }
  }

  const checkUserEmailIsUnique = async (email) => {
    await SalesDealsApi.isUserEmailUnique({email})
      .then((response) => {
        const isUnique = response.data.is_unique
        if(!isUnique){
          const msg = 'Email sudah terdaftar'
          pageUtils.setAlertMsg(msg, ALERT_TYPES.DANGER)
        }
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error?.response?.data || error)
      })
  }

  const checkUserPhoneIsUnique = async (phone) => {
    try {
      // const res = await SalesDealsApi.isUserPhoneUnique({ phone })
      // if (!res.data.is_unique) {
      //   pageUtils.setAlertMsg('Phone sudah terdaftar', ALERT_TYPES.DANGER)
      // }
      console.log(phone)
    } catch (e) {
      pageUtils.setApiErrorMsg(e.response?.data)
    }
  }

  return (
    <>
      <TitlePage mainTitle={ 'Buat Deals BKO (Pre-Order)' } />

      <Card body>
        <SalesDealsBkoCreateForm
          onSubmitForm={ handleSubmitForm }
          checkUserEmailIsUnique={ checkUserEmailIsUnique }
          checkUserPhoneIsUnique={ checkUserPhoneIsUnique }
        />
      </Card>
    </>
  )
}

SalesDealsBkoCreatePage.propTypes = propTypes
export default SalesDealsBkoCreatePage
